import Cookies from "universal-cookie";

const cookies = new Cookies();

// note the trailing slash
const apiUrl = process.env.REACT_APP_BASE_URL
  ? `${process.env.REACT_APP_BASE_URL}`
  : "/api/primary_allstateagencyportal/";

export const BACKEND_CONFIG = {
  apiUrl: apiUrl,
  set: (key, value) => {
    if (value) {
      if (storage) {
        storage.setItem(key, value);
      } else {
        cookies.set(key, value);
      }
    }
  },
  get: (key) => {
    if (storage) {
      return storage.getItem(key);
    } else {
      return cookies.get(key);
    }
  },
  remove: (key) => {
    if (storage) {
      storage.removeItem(key);
    } else {
      cookies.remove(key);
    }
  },
  clearAll: () => {
    if (storage) {
      storage.clear();
    }
  },
};

const storage = (function () {
  const uid = new Date().toUTCString();

  try {
    localStorage.setItem(uid, uid);
    const result = localStorage.getItem(uid) === uid;
    localStorage.removeItem(uid);

    return result && localStorage;
  } catch (exception) {}
})();

export const LOGIN_URL = "account/login";

export const SURPLUS_LINES_ROUTING = true;
